import React, {useEffect, useState} from "react";
import * as t from "counterpart";
import {Form} from "react-bootstrap";
import api from "../../../utilities/API";
import "./ShippingMethods.scss";

function ShippingMethods({onChange, className, title})
{
    const [methods, setMethods] = useState([]);
    const [selected, setSelected] = useState({});

    // load initial data
    useEffect(() => {
        api("commerce/shipping-methods/?active=1", {
            result: (data) => {
                setMethods(data || []);

                // set the first method by default
                if(data.length) {
                    const first = data[0];
                    setSelected(first);
                    if(onChange) {
                        onChange(first);
                    }
                }
            },
        });
    }, []);

    //
    const localOnChange = method => {
        setSelected(method);
        if(onChange) {
            onChange(method);
        }
    }

    return (
        <div id="shipping" className={className}>
            {title}

            {methods.map(method =>
                <label key={method.id} className={"method "+(method.id === selected.id ? "selected" : "")}>
                    <Form.Check
                        id={"shipping-"+method.id}
                        type="radio"
                        label={method.displayed_name}
                        checked={method.id === selected.id}
                        onChange={() => localOnChange(method)}
                    />

                    <div className="cost">{method.price ? method.price + " "+window.portalSetting("commerce.currency") : t(method.price ? "Continue for options" : "Free")}</div>
                </label>
            )}
        </div>
    )
}

export default ShippingMethods;
